import React from "react";
import {Route, Routes} from "react-router-dom";
import Stores from "./store/Stores";
import TenantList from "./tenant/TenantList";
import MerchantProfile from "./merchant-profile/MerchantProfile";
import MerchantProfileDetails from "./merchant-profile/MerchantProfileDetails";
import MerchantProfileAdd from "./merchant-profile/MerchantProfileAdd";
import HistorySearch from "./history/HistorySearch";
import PaymentProviderList from "./payment-providers/PaymentProviderList";
import PacProductList from "./pac-products/PacProductList";
import Transactions from './transactions/Transactions';
import Transaction from './transactions/Transaction';
import OfflineRiskPolicies from "./offline-risk/OfflineRiskPolicies";

function RightPane() {
    return (

        <div className="right-pane" style={{width: '100%', paddingLeft: 32, position: 'absolute', left: 330}}>
            <Routes>
                <Route path="/tenants/:tenantId/stores/:storeId/psp/:pspId/merchant-profile/:merchantProfileId" element={<MerchantProfileDetails/>} />
                <Route path="/tenants/:tenantId/stores/:storeId/merchant-profile/add" element={<MerchantProfileAdd/>}></Route>
                <Route path="/tenants/:tenantId/stores/:storeId" element={<MerchantProfile/>}></Route>
                <Route path="/stores" element={<Stores/>} />
                <Route path="/payment-providers" element={<PaymentProviderList/>} />
                <Route path="/pac-products" element={<PacProductList/>} />
                <Route path="/offline-risk" element={<OfflineRiskPolicies/>} />
                <Route path="/" element={<TenantList/>} />
                <Route path="/logs" element={<HistorySearch/>} />
                <Route path="/transaction/:transactionId" element={<Transaction/>} />
                <Route path="/transactions" element={<Transactions/>} />
            </Routes>
        </div>);
}

export default RightPane;